<div class="item-container pt-0">
    <div class="edit-icons" (click)="onCancel()">
        <i class="material-icons">close</i>
    </div>
    <div class="content"
        *ngIf="dialogData.content_type=='course practical'|| dialogData.content_type=='certificate access'|| dialogData.content_type=='wages' || dialogData.content_type == 'employee type'
         || dialogData.content_type=='employee_status' ">
        <div class="delete-img mt-4  text-center">
            <img src="assets/images/icons/are_you_sure.png" class="img-fluid" alt="">
        </div>
        <h5 class="text-center item-txt mt-3">{{"Are you sure you want to change "|translate}}{{dialogData.content_type|translate}}?</h5>
        <div class="item-small mt-3 text-center">Values will be changed.</div>
    </div>
    <div class="content" *ngIf="dialogData.content_type=='resubmit package'">
        <div class="delete-img mt-4  text-center">
            <img src="assets/images/icons/are_you_sure.png" class="img-fluid" alt="">
        </div>
        <h5 class="text-center item-txt mt-3 m-auto">{{"Are you sure you want to"|translate}}{{dialogData.content_type|translate}}?</h5>
        <div class="item-small mt-3 text-center">Please make sure you have made necessary changes before resubmitting.
        </div>
    </div>
    <div class="content" *ngIf="dialogData.content_type=='accept_reject'|| dialogData.content_type=='timeoff_request' ">
        <div class="delete-img mt-4  text-center">
            <img src="assets/images/icons/are_you_sure.png" class="img-fluid" alt="">
        </div>
        <h5 class="text-center item-txt mt-3 m-auto">{{"Are you sure you want to "|translate}}{{dialogData.data_type|translate}} this?</h5>
            <div class="item-small mt-3 text-center">Status will be changed.</div>
    </div>
    <div class="btn-container d-flex mt-4">
        <button color="" class="auth-form-btn outline-btn new-outline d-flex align-items-center justify-content-center"
            (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="warn" class="auth-form-btn  success-btn ms-3" type="submit"
            (click)="onConfirm()">Yes</button>

    </div>
</div>
<app-loading-spinner></app-loading-spinner>